export const MAX_CHARS_WHEN_COLLAPSED = 40;
